// Role/permission/user/group/capability endpoints wrap their payload:
// { statusMessage, errorCode, responseBody }. This unwraps it, throwing if the
// backend signals failure via errorCode (which can happen on an HTTP 200).
// Tolerates the older flat (un-wrapped) shape too, in case any endpoint hasn't
// been migrated yet.
export function unwrapResponse<T>(data: any): T {
    if (data && typeof data === 'object' && 'responseBody' in data) {
        if (data.errorCode && data.errorCode !== 'OK') {
            throw new Error(data.statusMessage || `API error: ${data.errorCode}`);
        }
        return data.responseBody as T;
    }
    return data as T;
}
